import { render, staticRenderFns } from "./Graphic.vue?vue&type=template&id=1b4ef550&scoped=true&"
import script from "./Graphic.vue?vue&type=script&lang=ts&"
export * from "./Graphic.vue?vue&type=script&lang=ts&"
import style0 from "./Graphic.vue?vue&type=style&index=0&id=1b4ef550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ef550",
  null
  
)

export default component.exports